module.exports = __webpack_public_path__ + "images/volkerstevinb62b04603481f8f765f6cf60e9168c63.png";